import { DataTable, FormSectionHeader, Loader } from "@/components";
import useStep6 from "./useStep6";
import { Card, CardContent } from "@/components/ui";

const Step6 = () => {
  const { columns, isLoading, auditHistory, pageNumber,
    setPageNumber, pageSize, setPageSize, sorting, setSorting } = useStep6();

  return (
    <Card className="shadow-none rounded-lg border-0">
      <CardContent>
        <FormSectionHeader className="text-[15px] font-semibold text-g-700">
          Audit Trail
        </FormSectionHeader>
        {isLoading ? <Loader /> :
          <div className="overflow-x-auto">
            <DataTable
              columns={columns}
              data={auditHistory}
              className="shadow-none rounded-none border-0"
              tableWrapperClassName="px-0"
              headerClass={{
                row: "border-g-200",
                cell: "text-primary",
              }}
              pageNumber={pageNumber}
              pageSize={pageSize}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              serverSidePagination={true}
              sorting={sorting}
              onSortingChange={setSorting}
            />
          </div>
        }
      </CardContent>
    </Card>
  );
};

export default Step6;
